"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitFieldProps = exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledIs = _interopRequireDefault(require("styled-is"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _HBText2 = require("../HBText/HBText.styles");
var _InfoCircle = _interopRequireDefault(require("@honeybook/icons/dist/icons/InfoCircle16"));
var _HBInfoIcon = _interopRequireDefault(require("../HBInfoIcon/HBInfoIcon"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBBaseFormField = function HBBaseFormField(props) {
  var children = props.children,
    margin = props.margin,
    placement = props.placement,
    disabled = props.disabled,
    className = props.className,
    width = props.width;
  return /*#__PURE__*/_react["default"].createElement(Container, {
    className: className,
    $disabled: disabled,
    $width: width,
    $margin: margin
  }, /*#__PURE__*/_react["default"].createElement(ControlWrapper, {
    $isFlexColumn: placement === 'top'
  }, placement === 'right' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children, /*#__PURE__*/_react["default"].createElement(Label, props)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Label, props), children)), /*#__PURE__*/_react["default"].createElement(Message, props));
};
HBBaseFormField.defaultProps = {
  placement: 'top',
  size: 'sm',
  showHintMessage: false,
  tooltipIcon: _InfoCircle["default"],
  tooltipIconColor: _colors["default"].textTertiary,
  tooltipIconHoverColor: _colors["default"].textSecondary,
  tooltipKeepOpenOnHover: false,
  width: '100%',
  withMessage: true
};
var _default = exports["default"] = HBBaseFormField;
var Label = function Label(_ref) {
  var label = _ref.label,
    subLabel = _ref.subLabel,
    caption = _ref.caption,
    placement = _ref.placement,
    required = _ref.required,
    size = _ref.size,
    _ref$labelSize = _ref.labelSize,
    labelSize = _ref$labelSize === void 0 ? size : _ref$labelSize,
    disabled = _ref.disabled,
    id = _ref.id,
    tooltip = _ref.tooltip,
    tooltipIcon = _ref.tooltipIcon,
    tooltipIconColor = _ref.tooltipIconColor,
    tooltipIconHoverColor = _ref.tooltipIconHoverColor,
    tooltipKeepOpenOnHover = _ref.tooltipKeepOpenOnHover,
    tooltipEnableInitialOpen = _ref.tooltipEnableInitialOpen,
    tooltipShouldSupportClickOutside = _ref.tooltipShouldSupportClickOutside,
    onTooltipOpen = _ref.onTooltipOpen,
    counterProps = _ref.counterProps;
  if (!label && !counterProps) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(LabelContainer, null, label && /*#__PURE__*/_react["default"].createElement(LabelInnerContainer, {
    htmlFor: id,
    $size: labelSize,
    $placement: placement,
    $disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(MainLabelContainer, null, /*#__PURE__*/_react["default"].createElement("span", null, label, required && ' *'), /*#__PURE__*/_react["default"].createElement(_HBInfoIcon["default"], {
    tooltip: tooltip,
    icon: tooltipIcon,
    iconColor: tooltipIconColor,
    iconHoverColor: tooltipIconHoverColor,
    keepOpenOnHover: tooltipKeepOpenOnHover,
    tooltipEnableInitialOpen: tooltipEnableInitialOpen,
    tooltipShouldSupportClickOutside: tooltipShouldSupportClickOutside,
    onTooltipOpen: onTooltipOpen
  })), subLabel && /*#__PURE__*/_react["default"].createElement(SubLabel, null, subLabel), caption && /*#__PURE__*/_react["default"].createElement(Caption, {
    $size: labelSize
  }, caption)), counterProps && /*#__PURE__*/_react["default"].createElement(Counter, {
    $isOverMax: counterProps.currLength > counterProps.maxLength,
    $size: size
  }, counterProps.currLength, "/", counterProps.maxLength));
};
var Message = function Message(_ref2) {
  var disabled = _ref2.disabled,
    error = _ref2.error,
    errorMessage = _ref2.errorMessage,
    hintMessage = _ref2.hintMessage,
    disabledMessage = _ref2.disabledMessage,
    showHintMessage = _ref2.showHintMessage,
    withMessage = _ref2.withMessage;
  var message = disabled ? disabledMessage : error ? errorMessage : hintMessage;
  if (!withMessage || !message) {
    return null;
  }
  var isVisible = error && !!errorMessage || disabled && !!disabledMessage || showHintMessage && !!hintMessage;
  var color = disabled ? 'textTertiary' : error ? 'red50' : 'textSecondary';
  return /*#__PURE__*/_react["default"].createElement(MessageContainer, {
    type: "caption12",
    $isVisible: isVisible,
    color: color
  }, message);
};
var SHARED_DUMMY_PROPS = {
  id: undefined,
  size: undefined,
  error: undefined,
  disabled: undefined,
  width: undefined
};
var FIELD_DUMMY_PROPS = {
  className: undefined,
  errorMessage: undefined,
  hintMessage: undefined,
  disabledMessage: undefined,
  withMessage: undefined,
  label: undefined,
  subLabel: undefined,
  caption: undefined,
  labelSize: undefined,
  placement: undefined,
  required: undefined,
  tooltip: undefined,
  tooltipIcon: undefined,
  tooltipIconColor: undefined,
  tooltipIconHoverColor: undefined,
  tooltipKeepOpenOnHover: undefined,
  tooltipEnableInitialOpen: undefined,
  tooltipShouldSupportClickOutside: undefined,
  onTooltipOpen: undefined,
  showHintMessage: undefined,
  margin: undefined
};
var splitFieldProps = exports.splitFieldProps = function splitFieldProps(props) {
  return Object.keys(props).reduce(function (acc, key) {
    if (key in SHARED_DUMMY_PROPS) {
      acc.fieldProps[key] = props[key];
      acc.inputProps[key] = props[key];
    } else if (key in FIELD_DUMMY_PROPS) {
      acc.fieldProps[key] = props[key];
    } else if (key === 'maxLength' && 'value' in props && typeof props.value === 'string') {
      acc.fieldProps.counterProps = {
        currLength: props.value.length,
        maxLength: props[key]
      };
    } else {
      acc.inputProps[key] = props[key];
    }
    return acc;
  }, {
    fieldProps: {},
    inputProps: {}
  });
};

// -------------------------- Styles -------------------------- //

var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBBaseFormField__Container",
  componentId: "sc-1a2urtv-0"
})(["width:", ";display:flex;flex-direction:column;position:relative;", " ", ""], function (_ref3) {
  var $width = _ref3.$width;
  return $width;
}, (0, _styledIs["default"])('$margin')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        margin: ", ";\n    "])), function (_ref4) {
  var $margin = _ref4.$margin;
  return $margin;
}), (0, _styledIs["default"])('$disabled')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n        &, * {\n            cursor: not-allowed !important;\n        }\n    "]))));
var ControlWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBBaseFormField__ControlWrapper",
  componentId: "sc-1a2urtv-1"
})(["display:flex;", ""], (0, _styledIs["default"])('$isFlexColumn')(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n        flex-direction: column;\n    "]))));
var LabelContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBBaseFormField__LabelContainer",
  componentId: "sc-1a2urtv-2"
})(["display:flex;align-items:flex-start;justify-content:space-between;gap:4px;"]);
var LabelInnerContainer = _styledComponents["default"].label.withConfig({
  displayName: "HBBaseFormField__LabelInnerContainer",
  componentId: "sc-1a2urtv-3"
})(["display:flex;flex-direction:column;color:", ";i{display:flex;}", ""], _colors["default"].textPrimary, function (_ref5) {
  var $placement = _ref5.$placement,
    $size = _ref5.$size,
    htmlFor = _ref5.htmlFor,
    $disabled = _ref5.$disabled;
  return (0, _styledComponents.css)(["cursor:", ";", " ", " ", ""], htmlFor ? 'pointer' : 'default', PLACEMENT_STYLES[$placement], LABEL_STYLES[$size], $disabled && (0, _styledComponents.css)(["&,*{color:", " !important;}"], _colors["default"].textTertiary));
});
var SubLabel = _styledComponents["default"].span.withConfig({
  displayName: "HBBaseFormField__SubLabel",
  componentId: "sc-1a2urtv-4"
})(["color:", ";"], _colors["default"].textSecondary);
var MainLabelContainer = _styledComponents["default"].span.withConfig({
  displayName: "HBBaseFormField__MainLabelContainer",
  componentId: "sc-1a2urtv-5"
})(["display:flex;align-items:center;gap:4px;"]);
var Caption = _styledComponents["default"].span.withConfig({
  displayName: "HBBaseFormField__Caption",
  componentId: "sc-1a2urtv-6"
})(["color:", ";", ""], _colors["default"].textSecondary, function (_ref6) {
  var $size = _ref6.$size;
  return CAPTION_STYLES[$size];
});
var LABEL_STYLES = {
  xs: _HBText2.newTextStyles.body12,
  sm: _HBText2.newTextStyles.body14,
  md: _HBText2.newTextStyles.body14,
  lg: _HBText2.newTextStyles.body16
};
var CAPTION_STYLES = {
  xs: _HBText2.newTextStyles.caption10,
  sm: _HBText2.newTextStyles.caption12,
  md: _HBText2.newTextStyles.caption12,
  lg: _HBText2.newTextStyles.body14
};
var PLACEMENT_STYLES = {
  top: (0, _styledComponents.css)(["padding:0 0 6px 0;"]),
  right: (0, _styledComponents.css)(["padding:0 0 0 8px;"]),
  left: (0, _styledComponents.css)(["&:only-child,~ *:last-child{padding:0 8px 0 0;}"])
};
var MessageContainer = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "HBBaseFormField__MessageContainer",
  componentId: "sc-1a2urtv-7"
})(["margin-top:4px;display:none;", ":focus-within &{display:inline;}", ""], Container, (0, _styledIs["default"])('$isVisible')(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n        display: inline;\n    "]))));
var Counter = _styledComponents["default"].span.withConfig({
  displayName: "HBBaseFormField__Counter",
  componentId: "sc-1a2urtv-8"
})(["color:", ";", " ", ""], _colors["default"].textSecondary, function (_ref7) {
  var $size = _ref7.$size;
  return $size && LABEL_STYLES[$size];
}, (0, _styledIs["default"])('$isOverMax')(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n        color: ", ";\n    "])), _colors["default"].red50));
//# sourceMappingURL=HBBaseFormField.js.map